import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _react, { useContext, useLayoutEffect, useMemo, useState } from "react";
var $f01a183cc7bdff77849e49ad26eb904$var$defaultContext = {
  prefix: Math.round(Math.random() * 10000000000),
  current: 0
};

var $f01a183cc7bdff77849e49ad26eb904$var$SSRContext = _react.createContext($f01a183cc7bdff77849e49ad26eb904$var$defaultContext);

export function SSRProvider(props) {
  var cur = useContext($f01a183cc7bdff77849e49ad26eb904$var$SSRContext);
  var value = useMemo(function () {
    return {
      prefix: cur === $f01a183cc7bdff77849e49ad26eb904$var$defaultContext ? 0 : ++cur.prefix,
      current: 0
    };
  }, [cur]);
  return _react.createElement($f01a183cc7bdff77849e49ad26eb904$var$SSRContext.Provider, {
    value: value
  }, props.children);
}
var $f01a183cc7bdff77849e49ad26eb904$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
export function useSSRSafeId(defaultId) {
  var ctx = useContext($f01a183cc7bdff77849e49ad26eb904$var$SSRContext);

  if (ctx === $f01a183cc7bdff77849e49ad26eb904$var$defaultContext && !$f01a183cc7bdff77849e49ad26eb904$var$canUseDOM) {
    console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
  }

  return useMemo(function () {
    return defaultId || "react-aria-" + ctx.prefix + "-" + ++ctx.current;
  }, [defaultId]);
}
export function useIsSSR() {
  var cur = useContext($f01a183cc7bdff77849e49ad26eb904$var$SSRContext);
  var isInSSRContext = cur !== $f01a183cc7bdff77849e49ad26eb904$var$defaultContext;

  var _useState = useState(isInSSRContext),
      _useState2 = _slicedToArray(_useState, 2),
      isSSR = _useState2[0],
      setIsSSR = _useState2[1];

  if (typeof window !== 'undefined' && isInSSRContext) {
    useLayoutEffect(function () {
      setIsSSR(false);
    }, []);
  }

  return isSSR;
}